import { createSlice } from '@reduxjs/toolkit';


const COLLABORATE_HOST_STATUS = {
  CONNECTED: 'connected',
  DISCONNECTED: 'disconnected'
};

const COLLABORATE_DEFAULT = {
  isRequesting: false,
  isJoining: false,
  isLeaving: false,
  leftReason: null,
  participantType: '',
  stageId: '',
  requestList: [],
  host: { username: '', status: '' }
};

const INITIAL_STATE = {
  success: null,
  error: null,
  neutral: null,
  collaborate: COLLABORATE_DEFAULT
};

export const sharedSlice = createSlice({
  name: 'shared',
  initialState: INITIAL_STATE,
  reducers: {
    resetSharedStates: () => {
      return INITIAL_STATE;
    },
    updateError: (state, action) => {
      state.error = action.payload;
    },
    updateSuccess: (state, action) => {
      state.success = action.payload;
    },
    updateNeutral: (state, action) => {
      state.neutral = action.payload;
    },
    clearCollaborate: (state) => {
      state.collaborate = COLLABORATE_DEFAULT;
    },
    addToCollaborateRequestList: (state, action) => {
      state.collaborate.requestList = [
        ...state.collaborate.requestList,
        action.payload
      ];
    },
    removeFromCollaborateRequestList: (state, action) => {
      const channelId = action.payload;

      state.collaborate.requestList = state.collaborate.requestList.filter(
        (requestee) => requestee.channelId !== channelId.toLowerCase()
      );
    },
    updateCollaborateStates: (state, action) => {
      const revokingRequest =
        !action.payload.isJoining && action.payload.isRequesting === false;

      state.collaborate = {
        ...state.collaborate,
        // when isRequesting is true, joining must be false
        ...(action.payload.isRequesting && {
          isJoining: false
        }),
        ...(revokingRequest && {
          participantType: '',
          stageId: ''
        }),
        // when isJoining is true, isRequesting must be false
        ...(action.payload.isJoining && {
          isRequesting: false
        }),
        ...action.payload
      };
    },
    updateCollaborateHost: (state, action) => {
      state.collaborate.host = {
        ...state.collaborate.host,
        ...action.payload
      };
    }
  }
});


export const {
  addToCollaborateRequestList,
  clearCollaborate,
  removeFromCollaborateRequestList,
  resetSharedStates,
  updateCollaborateHost,
  updateCollaborateStates,
  updateError,
  updateSuccess,
  updateNeutral
} = sharedSlice.actions;
export {
  COLLABORATE_DEFAULT,
  COLLABORATE_HOST_STATUS,
};
export default sharedSlice.reducer;
